module.exports = __webpack_public_path__ + "img/cover-4.2cb6a64f.png";